export const servicesList = [
  // {
  //   Id: 1,
  //   Name: 'Basis',
  //   path: 'basis',
  // },
  {
    Id: 11,
    Name: 'Alarms',
    path: 'alarms',
  },
  {
    Id: 12,
    Name: 'Devices',
    path: 'devices',
  },
  {
    Id: 13,
    Name: 'Analytics',
    path: 'analytics',
  },
  {
    Id: 3,
    Name: 'EnergyXplorer',
    path: 'energyxplorer',
  },
  {
    Id: 5,
    Name: 'PortfolioAnalysis',
    path: 'portfolio-analysis',
  },
  {
    Id: 18,
    Name: 'EnergyXplorerAnalytics',
    path: 'energyxplorer-analytics',
  },
  {
    Id: 6,
    Name: 'DatahubIntegration',
    path: 'datahub-integration',
  },
  {
    Id: 16,
    Name: 'EforsyningIntegration',
    path: 'eforsyning-integration',
  },
  {
    Id: 17,
    Name: 'DaluxIntegration',
    path: 'dalux-integration',
  },
  {
    Id: 7,
    Name: 'DashboardPowerBasic',
    path: 'dashboard-power-basic',
  },
  {
    Id: 8,
    Name: 'DashboardWaterBasic',
    path: 'dashboard-water-basic',
  },
  {
    Id: 9,
    Name: 'DashboardHeatBasic',
    path: 'dashboard-heat-basic',
  },
  {
    Id: 10,
    Name: 'DashboardCompressedAir',
    path: 'compressed-air',
  },
  // {
  //   Id: 15,
  //   Name: 'DashboardLegacy',
  //   path: 'powerbi',
  // },
  {
    Id: 2,
    Name: 'PVO',
    path: 'predictive-heat-control',
  },
  {
    Id: 14,
    Name: 'Scheduler',
    path: 'scheduler',
  },
  {
    Id: 4,
    Name: 'JyskEnergiESG',
    path: 'jyskenergiesg',
  },
];
